import React__default from 'react';
import { a as SkeletonContainer, P as Panel, S as Skeleton } from './SkeletonContainer-bb887edb.js';
import { ai as createClassName } from './className-ac5eca03.js';

const PanelSkeleton = ({ hasTitle = true, hasBottomLink = false, titleWidth = '30%', hasRole, children }) => {
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole, className: className() },
        React__default.createElement(Panel, null,
            hasTitle && React__default.createElement(Panel.Header, null,
                React__default.createElement(Skeleton, { variant: "rectangular", height: 24, width: titleWidth })),
            children,
            hasBottomLink && React__default.createElement("div", { className: className('bottomLink') },
                React__default.createElement(Skeleton, { width: "35%" }))));
};
const className = createClassName('PanelSkeleton');

export { PanelSkeleton as P };
